import styled, { css } from 'styled-components';

export const Place = styled.div`
  margin: 0 0 10px;

  label {
    margin: 0 10px 0 0;
  }

  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      display: flex;
      align-items: center;
      text-align: left;
      label {
        width: 86px;
        flex-shrink: 0;
        text-align: right;
      }
    `}
`;
